
import React, { Component } from 'react';
import './setGroupPage.less';
import group from "../../../imgs/item/group.png";
import { getAllGroupsAndDevices } from '../../../utils/meshUtils';
import { meshLog, SPGet } from '../../../utils/spUtils';
import { getGroupNormalImgWithName } from '../../../utils/fileUtils';
import PubSub from 'pubsub-js'
import { editEmergencyGroup, getEmergencyInfo } from '../../../utils/scheduleUtils';

export default class SetGroupPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
        };
    }

    componentDidMount() {
        PubSub.subscribe("update_emergency_Set_dialog", (msg, index) => {
            this.updateEmerSetGroupUI();
        })
    }

    updateEmerSetGroupUI(){
        let sceneValue=parseInt(SPGet("emergencyNmber"));

        let arr1=getEmergencyInfo(1);
        let arr2=getEmergencyInfo(2);
        let arr3=getEmergencyInfo(3);

        if(sceneValue==1){
            this.judgeGroupArr(arr1.groupIDs,arr2.groupIDs,arr3.groupIDs);
        }else if(sceneValue==2){
            this.judgeGroupArr(arr2.groupIDs,arr1.groupIDs,arr3.groupIDs);
        }else if(sceneValue==3){
            this.judgeGroupArr(arr3.groupIDs,arr1.groupIDs,arr2.groupIDs);
        }
    }

    judgeGroupArr(arr1,arr2,arr3){
        meshLog('judgeGroupArr', arr1,arr2,arr3);
        let list=getAllGroupsAndDevices();
        // meshLog('list start', list);
        let arr=[];
        let count=0;
        for(let i=0;i<list.length;i++){
            let isDel=false;
            list[i].checked=false;
            for(let j=0;j<arr1.length;j++){
                if(list[i].id==arr1[j]){
                    list[i].checked=true;
                }
            }
            for(let j=0;j<arr2.length;j++){
                if(list[i].id==arr2[j]){
                    isDel=true;
                }
            }
            for(let j=0;j<arr3.length;j++){
                if(list[i].id==arr3[j]){
                    isDel=true;
                }
            }
            if(!isDel){
                arr[count]=list[i];
                count++;
            }
        }
        // meshLog('list end', arr);
        this.setState({ groups: arr });
    }



    //多选框
    handleCheckboxChange = (id) => {
        let arr = this.state.groups;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == id) {
                arr[i].checked = !arr[i].checked;
            }
        }
        // meshLog('arr', arr);
        this.setState({ groups: arr });
    };


    //关闭弹窗
    sendDataToParent() {
        this.props.onDataToParent("");
    };
    //保存
    sendDataToParentOK() {
        this.props.onDataToParent("");
        let list = this.state.groups;
        let arr=[];
        let count=0;
        for (let i = 0; i < list.length; i++) {
            if (list[i].checked) {
                arr[count]=list[i].id;
                count++;
            }
        }
        editEmergencyGroup(arr);
    };


    render() {
        return (
            <div className="groupSet_container">
                {/* 标题行 */}
                <div className="item_row">
                    <div className="item_title">
                        <img src={group} />
                        <span>Associated Group</span>
                    </div>
                </div>

                {/* group列表 */}
                <div className="group_list">
                    {this.state.groups.map((group) => (
                        <div key={group.id} className="group_item">
                            <img className="group-icon" src={getGroupNormalImgWithName(group.name)} />
                            <span>{group.name}</span>
                            <input className="radioSet" type='checkbox' name='group' value='' checked={group.checked} onChange={() => this.handleCheckboxChange(group.id)} />
                        </div>
                    ))}
                </div>




                {/* 底部按钮 */}
                <div className="groupSet_footer">
                    <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                    <button className='okBtn' onClick={this.sendDataToParentOK.bind(this)}>Confirm</button>
                </div>


            </div>

        );
    }
}
